export const getTabProps = <T>(tab: T) => {
    return {
        id: `tab-id-${tab}`,
        value: tab,
        label: tab,
    };
};
